// extracted by css-extract-rspack-plugin
var _1 = "XqFbBW80t5gBJk6B";
var _2 = "Q8O9_dNSYtMxDEix";
var _3 = "dRxeV6HfFksXpDjI";
var _4 = "IdaTlVNelMO7nvJD";
var _5 = "YDZT84LFIIs6sdTx";
var _6 = "ynl5hXlfwTkEZrV7";
var _7 = "srEanYj05mM4DjcA";
var _8 = "xHejga2Fh_sS_Zkv";
var _9 = "Kc1h849M89EuT6i8";
var _a = "LEUUOYIvuIrrg5hl";
var _b = "pjrNYocnMKAhbWaI";
var _c = "J37TOcZQku42E08n";
var _d = "_TRfjFWBksgqlyLa";
var _e = "C0R58eJsCwWeM8WW";
var _f = "Q8O9_dNSYtMxDEix";
var _10 = "dRxeV6HfFksXpDjI";
var _11 = "IdaTlVNelMO7nvJD";
var _12 = "YDZT84LFIIs6sdTx";
var _13 = "ynl5hXlfwTkEZrV7";
var _14 = "srEanYj05mM4DjcA";
var _15 = "_TRfjFWBksgqlyLa";
var _16 = "xHejga2Fh_sS_Zkv";
var _17 = "Kc1h849M89EuT6i8";
var _18 = "LEUUOYIvuIrrg5hl";
var _19 = "pjrNYocnMKAhbWaI";
var _1a = "J37TOcZQku42E08n";
var _1b = "C0R58eJsCwWeM8WW";
export { _1 as "disabled", _2 as "ts-card--medium", _3 as "ts-card--squared", _4 as "ts-rank", _5 as "ts-rank__label", _6 as "ts-scored", _7 as "ts-scored-data", _8 as "ts-scored-head", _9 as "ts-scored-label", _a as "ts-scored-left", _b as "ts-scored-other", _c as "ts-scored-right", _d as "ts-scored__datas", _e as "ts-scored__title", _f as "tsCardMedium", _10 as "tsCardSquared", _11 as "tsRank", _12 as "tsRankLabel", _13 as "tsScored", _14 as "tsScoredData", _15 as "tsScoredDatas", _16 as "tsScoredHead", _17 as "tsScoredLabel", _18 as "tsScoredLeft", _19 as "tsScoredOther", _1a as "tsScoredRight", _1b as "tsScoredTitle" }
